import React from "react";
import "./CAD.css";
import CADim from "../../../Gallery/ServicesImages/M3/CAD.jpg";
import { useNavigate } from "react-router-dom";


function CADModelling() {

    const navigate = useNavigate();

  return (
    <section className="cad-section">

      <div className="cad-container">

        {/* LEFT IMAGE */}
        <div className="cad-image">
          <img src={CADim} alt="CAD Modelling Software" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="cad-content">

          <h1>CAD Modelling Software</h1>
          <div className="underline"></div>

          <p>
            CAD Modelling software plays a critical role in product design and 
            development by enabling engineers to create precise digital 
            representations of components and assemblies. These tools allow 
            designers to visualize, modify, and analyze models before committing 
            to physical production, reducing costly errors and improving efficiency.
          </p>

          <p>
            Additionally, CAD tools offer simulation, drafting, test-case 
            generation, and model-based validation features. This ensures proper 
            structural integrity, manufacturability, and functional performance. 
            Whether used for mechanical systems, mould design, or product 
            engineering, CAD modelling remains essential for modern manufacturing.
          </p>

          <button className="cad-btn" onClick={() => navigate("/contact")}>Contact</button>

        </div>

      </div>

    </section>
  );
}

export default CADModelling;
